<template>
	<div class="patient-list bg-white">
		<DoctorCard ref="doctorCard" />
		<PatientList class="patient_list" @onPatientList="checkPatientList" />
		<foot-button>
			<van-button type="primary" block icon="plus" @click="clickCreatePatient">新建患者</van-button>
		</foot-button>
	</div>
</template>

<script>
import DoctorCard from './components/doctor-card.vue'
import PatientList from './components/patient-list.vue'
export default {
    name: 'create-patient',
    components: { DoctorCard, PatientList },
    computed: {
        teamId () {
            return this.$route.params.teamId
        }
    },
    mounted () {
        this.$refs.doctorCard.getDoctorDetail(this.$route.params.id)
        if (this.teamId) {
            this.$refs.doctorCard.getTeamDetail({}, this.teamId)
        }

    },
    methods: {
        clickCreatePatient () {
            this.$router.push(`/dpbind/create/${this.$route.params.id}${this.teamId ? ('/' + this.teamId) : ''}`)
        },
        // 判断绑定患者是否为空
        checkPatientList (list) {
            console.log(list)
            if (!list || !list.length) {
                this.clickCreatePatient()
            }
        }
    }
};
</script>

<style scoped lang="less">
.patient-list {
	min-height: calc(100vh - 216px);
	padding: 40px;
	.patient_list {
		margin-top: 80px;
	}
}
</style>
